import { Component, type OnInit, inject } from "@angular/core";
import { FooterComponent } from "@coreui/angular";
import { AccountService, type IUser } from "../../../core";
import {
    Feature,
    FeatureService,
} from "../../../shared/feature/feature.service";

@Component({
    selector: "app-default-footer",
    templateUrl: "./default-footer.component.html",
    styleUrls: ["./default-footer.component.scss"],
    standalone: false,
})
export class DefaultFooterComponent extends FooterComponent implements OnInit {
    private accountService = inject(AccountService);
    featureService = inject(FeatureService);

    currentAccount: IUser;
    year = new Date().getFullYear();
    ngOnInit(): void {
        this.accountService.identity().then((account) => {
            this.currentAccount = account;
        });
    }

    protected readonly Feature = Feature;
}
